import I from "./ghl-ui.es369.js";
import "./ghl-ui.es370.js";
import "./ghl-ui.es371.js";
import "./ghl-ui.es372.js";
import "./ghl-ui.es373.js";
import "./ghl-ui.es363.js";
import "./ghl-ui.es364.js";
import { SortableStartEvent as N, SortableSortEvent as S, SortableSortedEvent as C, SortableStopEvent as w } from "./ghl-ui.es377.js";
const d = Symbol("onDragStart"), l = Symbol("onDragOverContainer"), c = Symbol("onDragOver"), h = Symbol("onDragStop");
function E({
  dragEvent: n
}) {
  const t = n.source.textContent.trim() || n.source.id || "sortable element";
  if (n.over) {
    const e = n.over.textContent.trim() || n.over.id || "sortable element";
    return n.source.compareDocumentPosition(n.over) & Node.DOCUMENT_POSITION_FOLLOWING ? `Placed ${t} after ${e}` : `Placed ${t} before ${e}`;
  } else
    return `Placed ${t} into a different container`;
}
const D = {
  "sortable:sorted": E
};
class _ extends I {
  constructor(t = [], e = {}) {
    super(t, {
      ...e,
      announcements: {
        ...D,
        ...e.announcements || {}
      }
    }), this.startIndex = null, this.startContainer = null, this[d] = this[d].bind(this), this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[h] = this[h].bind(this), this.on("drag:start", this[d]).on("drag:over:container", this[l]).on("drag:over", this[c]).on("drag:stop", this[h]);
  }
  destroy() {
    super.destroy(), this.off("drag:start", this[d]).off("drag:over:container", this[l]).off("drag:over", this[c]).off("drag:stop", this[h]);
  }
  index(t) {
    return this.getSortableElementsForContainer(t.parentNode).indexOf(t);
  }
  getSortableElementsForContainer(t) {
    return [...t.querySelectorAll(this.options.draggable)].filter((r) => r !== this.originalSource && r !== this.mirror && r.parentNode === t);
  }
  [d](t) {
    this.startContainer = t.source.parentNode, this.startIndex = this.index(t.source);
    const e = new N({
      dragEvent: t,
      startIndex: this.startIndex,
      startContainer: this.startContainer
    });
    this.trigger(e), e.canceled() && t.cancel();
  }
  [l](t) {
    if (t.canceled())
      return;
    const {
      source: e,
      over: r,
      overContainer: o
    } = t, i = this.index(e), s = new S({
      dragEvent: t,
      currentIndex: i,
      source: e,
      over: r
    });
    if (this.trigger(s), s.canceled())
      return;
    const u = this.getSortableElementsForContainer(o), a = x({
      source: e,
      over: r,
      overContainer: o,
      children: u
    });
    if (!a)
      return;
    const {
      oldContainer: f,
      newContainer: g
    } = a, p = this.index(t.source), m = new C({
      dragEvent: t,
      oldIndex: i,
      newIndex: p,
      oldContainer: f,
      newContainer: g
    });
    this.trigger(m);
  }
  [c](t) {
    if (t.over === t.originalSource || t.over === t.source)
      return;
    const {
      source: e,
      over: r,
      overContainer: o
    } = t, i = this.index(e), s = new S({
      dragEvent: t,
      currentIndex: i,
      source: e,
      over: r
    });
    if (this.trigger(s), s.canceled())
      return;
    const u = this.getDraggableElementsForContainer(o), a = x({
      source: e,
      over: r,
      overContainer: o,
      children: u
    });
    if (!a)
      return;
    const {
      oldContainer: f,
      newContainer: g
    } = a, p = this.index(e), m = new C({
      dragEvent: t,
      oldIndex: i,
      newIndex: p,
      oldContainer: f,
      newContainer: g
    });
    this.trigger(m);
  }
  [h](t) {
    const e = new w({
      dragEvent: t,
      oldIndex: this.startIndex,
      newIndex: this.index(t.source),
      oldContainer: this.startContainer,
      newContainer: t.source.parentNode
    });
    this.trigger(e), this.startIndex = null, this.startContainer = null;
  }
}
function b(n) {
  return Array.prototype.indexOf.call(n.parentNode.children, n);
}
function x({
  source: n,
  over: t,
  overContainer: e,
  children: r
}) {
  const o = !r.length, i = n.parentNode !== e, s = t && n.parentNode === t.parentNode;
  return o ? O(n, e) : s ? v(n, t) : i ? y(n, t, e) : null;
}
function O(n, t) {
  const e = n.parentNode;
  return t.appendChild(n), {
    oldContainer: e,
    newContainer: t
  };
}
function v(n, t) {
  const e = b(n), r = b(t);
  return e < r ? n.parentNode.insertBefore(n, t.nextElementSibling) : n.parentNode.insertBefore(n, t), {
    oldContainer: n.parentNode,
    newContainer: n.parentNode
  };
}
function y(n, t, e) {
  const r = n.parentNode;
  return t ? t.parentNode.insertBefore(n, t) : e.appendChild(n), {
    oldContainer: r,
    newContainer: n.parentNode
  };
}
export {
  _ as default
};
